var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, FormGroup, Input, Form, Card, CardFooter, CardBody, Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import FormField from '../../components/ui/FormField/FormField';
import { FormErrorContext } from '../../../FormErrorContext';
import ServiceSchemaSearch from '../../components/ui/ServiceSchemaSearch/ServiceSchemaSearch';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import GetServiceSchemasCommand from '../../../commands/services/GetServiceSchemasCommand';
import DateInput from '../../components/ui/DateInput/DateInput';
import CreateManualServiceEntryCommand from '../../../commands/services/CreateManualServiceEntryCommand';
import ServiceEntryPriority from '../../../data/ServiceEntryPriority';
import AssetSearch from '../../components/ui/AssetSearch/AssetSearch';
/**
 *
 */
var CreateManualServiceEntryOverlay = /** @class */ (function (_super) {
    __extends(CreateManualServiceEntryOverlay, _super);
    /**
     *
     * @param props
     */
    function CreateManualServiceEntryOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            schemaModel: null,
            tags: []
        };
        _this.onScheduledDateChange = _this.onScheduledDateChange.bind(_this);
        _this.onDateChange = _this.onDateChange.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onSelectSchema = _this.onSelectSchema.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSelectAsset = _this.onSelectAsset.bind(_this);
        return _this;
    }
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    CreateManualServiceEntryOverlay.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    CreateManualServiceEntryOverlay.prototype.initialize = function () {
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection;
        var assetModel = this.props.assetModel;
        var user = session.user;
        this.onSelectAsset([assetModel]);
        var command = new GetServiceSchemasCommand();
        command.execute(user, serviceSchemaCollection);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    CreateManualServiceEntryOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl;
        var _b = this.context, serviceSchemaCollection = _b.serviceSchemaCollection, assetCollection = _b.assetCollection;
        var _c = this.state, errors = _c.errors, assetModel = _c.assetModel, schemaModel = _c.schemaModel, dueDate = _c.dueDate, scheduledDate = _c.scheduledDate, name = _c.name, description = _c.description, operatorName = _c.operatorName, assignedTo = _c.assignedTo, priority = _c.priority;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return React.createElement(Container, { className: 'create-manual-service-entry-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'service.schema.assign.manual.overlay.title' }, assetModel ? assetModel : { id: '-' }) }),
                        React.createElement(CardBody, null,
                            React.createElement(Row, null,
                                !this.props.assetModel &&
                                    React.createElement(Col, { sm: 12 },
                                        React.createElement(FormGroup, null,
                                            React.createElement(Row, null,
                                                React.createElement(Col, null,
                                                    React.createElement("label", { htmlFor: "description" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.asset" })))),
                                            React.createElement("div", { className: "w-100 d-flex align-items-start" },
                                                React.createElement(AssetSearch, { value: assetModel, assetCollection: assetCollection, onChange: this.onSelectAsset })))),
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "description" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.schema" })))),
                                        React.createElement("div", { className: "w-100 d-flex align-items-start" },
                                            React.createElement(ServiceSchemaSearch, { value: schemaModel, manualOnly: true, serviceSchemaCollection: serviceSchemaCollection, onChange: this.onSelectSchema })))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "scheduledDate" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.scheduleddate" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group", "data-errorHandler": "scheduledDate" },
                                                React.createElement(DateInput, { intl: intl, id: "scheduledDate", name: "scheduledDate", onBlur: this.onScheduledDateChange, onChange: this.onScheduledDateChange, value: scheduledDate, openToDate: scheduledDate }),
                                                React.createElement("div", { className: "input-group-append" },
                                                    React.createElement("span", { className: "input-group-text" },
                                                        React.createElement("i", { className: "fe fe-calendar" }))))))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "name" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.duedate" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement(DateInput, { intl: intl, id: "dueDate", name: "dueDate", onBlur: this.onDateChange, onChange: this.onDateChange, value: dueDate, openToDate: dueDate }),
                                                React.createElement("div", { className: "input-group-append" },
                                                    React.createElement("span", { className: "input-group-text" },
                                                        React.createElement("i", { className: "fe fe-calendar" }))))))),
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "name" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.name" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "name", type: "text", name: "name", value: name })))),
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "description" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.description" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("textarea", { className: "form-control", id: "description", name: "description" }, description)))),
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "priority" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.priority" })))),
                                        React.createElement("div", { className: "input-group w-100 d-flex align-items-start" },
                                            React.createElement("select", { id: "priority", name: "priority", className: "form-control w-100", value: priority }, ServiceEntryPriority.getKeys().map(function (key) {
                                                return React.createElement("option", { value: ServiceEntryPriority[key].value }, intl.formatMessage({ id: 'service.entry.priority.' + key }));
                                            }))))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "assignedTo" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.assignedto" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "assignedTo", type: "text", name: "assignedTo", value: assignedTo })))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "operator" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.operator" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "operator", type: "text", name: "operatorName", value: operatorName })))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit", disabled: !assetModel || !schemaModel },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    CreateManualServiceEntryOverlay.prototype.onInputChange = function (event) {
        var newState = {};
        switch (event.target.name) {
            case 'dueDate':
            case 'scheduledDate':
                // do nothing
                break;
            default:
                newState[event.target.name] = event.target.value;
        }
        this.setState(newState);
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.onDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ dueDate: date });
        }
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.onScheduledDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ scheduledDate: date });
        }
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.onSelectSchema = function (schemaModel) {
        this.setState({ schemaModel: schemaModel });
    };
    /**
     *
     * @param event
     */
    CreateManualServiceEntryOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var assetModel = this.state.assetModel;
        var _a = this.state, dueDate = _a.dueDate, scheduledDate = _a.scheduledDate, schemaModel = _a.schemaModel, name = _a.name, description = _a.description, assignedTo = _a.assignedTo, operatorName = _a.operatorName, priority = _a.priority, tags = _a.tags;
        if (!schemaModel || !assetModel) {
            return;
        }
        if (dueDate != null && scheduledDate != null) {
            if (dueDate.getTime() < scheduledDate.getTime()) {
                Signals.ShowNotification.dispatch(intl.formatMessage({ id: "service.entry.error.duedate.before.scheduleddate" }), 'danger');
                return;
            }
        }
        var data = {
            dueDateTimestamp: dueDate ? dueDate.getTime() : null,
            scheduledDateTimestamp: scheduledDate ? scheduledDate.getTime() : null,
            assetId: assetModel.getAssetSerial(),
            schemaId: schemaModel.id,
            name: name,
            description: description,
            assignedTo: assignedTo,
            operatorName: operatorName,
            priority: priority,
            tags: tags.map(function (tag) {
                return { name: tag };
            })
        };
        var command = new CreateManualServiceEntryCommand();
        command.execute(data, session.user.organisation, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     * @param assetModels
     */
    CreateManualServiceEntryOverlay.prototype.onSelectAsset = function (assetModels) {
        if (assetModels && assetModels.length > 0 && assetModels[0]) {
            var assetModel = assetModels[0];
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.setState({
                assetModel: assetModel,
                firstHours: Math.ceil(assetModel.cumulativeOperatingHoursDurationInHours),
                dueDate: tomorrow
            });
        }
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    CreateManualServiceEntryOverlay.prototype.onSuccess = function () {
        var successCallback = this.props.successCallback;
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        // if success callback function is defined, call it
        if (successCallback) {
            successCallback();
        }
    };
    /**
     *
     * @param error
     */
    CreateManualServiceEntryOverlay.prototype.onError = function (error) {
        // Convert errors
        try {
            var errors = error.error.response.body.errors;
            var errorKeys = Object.keys(errors);
            errorKeys.forEach(function (key) {
                if (key.indexOf('ScheduledDateTimeCannotBeAfterDueDate') > 0) {
                    error.error.response.body.errors[key] = null;
                    error.error.response.body.errors['scheduledDate'] = ['serviceentry.error.scheduledatebeforeduedate'];
                }
            });
        }
        catch (e) { }
        createErrorResponse(this, error);
    };
    CreateManualServiceEntryOverlay.defaultProps = {
        className: ''
    };
    CreateManualServiceEntryOverlay = __decorate([
        observer
    ], CreateManualServiceEntryOverlay);
    return CreateManualServiceEntryOverlay;
}(React.Component));
CreateManualServiceEntryOverlay.contextType = ApplicationContext;
export default injectIntl(CreateManualServiceEntryOverlay);
